import {
  CachedOutlined,
  DownloadOutlined,
  FilePresentOutlined,
} from "../../materialUi/materialUi";
import { ButtonDS } from "../Button";
import { FileInputButton } from "../../../components/input/FileInputButton";
import { Spacer } from "../Spacer";
import { colors } from "../../../styles/figmaColors";
import { typographies } from "../../../styles/figmaTypographies";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export type ImportDisplayFileProps = {
  selectedFile?: string;
  handleFileChange?: (file: File | null) => void;
  handleDownload?: () => void;
  type: "REPLACE" | "DOWNLOAD";
};

export const ImportDisplayFile = (props: ImportDisplayFileProps) => {
  const { t } = useTranslation();

  return (
    <StyledFlex>
      <Spacer x={0.75} />
      <StyledDisplayFile>
        <StyledLeft>
          <StyledIcon>
            <FilePresentOutlined />
          </StyledIcon>
          <Spacer x={0.5} />
          {props.selectedFile}
        </StyledLeft>
        <Spacer x={0.25} />
        {props.type === "REPLACE" ? (
          <FileInputButton
            handleFile={(file) => props.handleFileChange?.(file)}
          >
            <ButtonDS
              format="hug"
              buttonType={"secondary"}
              text={t(`vehicles.modal.addMultipleVehicles.button.replace`)}
              leftIcon={<CachedOutlined />}
            />
          </FileInputButton>
        ) : (
          <StyledDownload>
            <ButtonDS
              text={t(`vehicles.modal.addMultipleVehicles.button.download`)}
              leftIcon={<DownloadOutlined />}
              format="hug"
              buttonType="secondary"
              onClick={props.handleDownload}
            />
          </StyledDownload>
        )}
      </StyledDisplayFile>
      <Spacer x={0.75} />
    </StyledFlex>
  );
};

const StyledFlex = styled.div`
  display: flex;
  width: 100%;
`;

const StyledDisplayFile = styled.div`
  width: 100%;
  display: flex;
  border: 0.0625rem solid ${colors["colors/borders/cards/cards"]};
  padding: 0.75rem;
  border-radius: 0.5rem;
  justify-content: space-between;
  align-items: center;
  ${typographies["Body/M"]};
  color: ${colors["colors/accent/600"]};
`;

const StyledLeft = styled.div`
  display: flex;
  align-items: center;
`;

const StyledDownload = styled.div`
  &:focus {
    outline: none;
  }
`;

const StyledIcon = styled.div`
  & svg {
    fill: ${colors["colors/accent/600"]};
  }
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 2.25rem;
  height: 2.25rem;
  background-color: ${colors["colors/surfaces/background/background_level0"]};
  border-radius: 0.5rem;
  border: 0.0625rem solid ${colors["colors/borders/cards/cards"]};
`;
